
  import { createApiClient } from 'Network/ApiClient';
  
  export const IcdNotCoveredAxiosInstance = createApiClient('IcdNotCovered/');


